import { capitalize } from '@/utils';

export default {
  computed: {
    fiveStarRating() {
      if (this.rating?.ratingType === 'fivestar') {
        return this.rating.rating || 0;
      }
      return 0;
    },
    ratingKey() {
      return `${this.rateableType}-${this.rateableId}`;
    },
    rating() {
      return this.$store.getters['ratings/get'][this.ratingKey];
    },
  },
  methods: {
    rate(direction, asset, category) {
      let deselected = false;
      let rating = null;
      let assetType = this.rateableType;
      if (assetType === 'Attachment') {
        assetType = capitalize(asset.mediaType);
      }

      const eventParams = {
        'Asset ID': asset.id,
        'Asset Title': this.ratedAssetTitle(asset),
        'Category ID': category?.id,
        'Category Name': category?.name,
        'Asset Type': assetType,
      };

      if (this.rating?.hasRating()) {
        // from up to down
        if (this.rating.rating === 1 && direction === 'down') {
          rating = 0;

        // from down to up
        } else if (this.rating.rating === 0 && direction === 'up') {
          rating = 1;

          // user is deselecting rating
        } else {
          deselected = true;
        }
      } else {
        rating = direction === 'up' ? 1 : 0;
      }

      if (this.rateableType !== 'Discussion') {
        if (deselected) {
          this.$analytics.events.removedAssetRating({
            ...eventParams,
            'Rated': this.rating.rating === 1 ? 'Upvote' : 'Downvote',
          });
        } else {
          this.$analytics.events.ratedAsset({
            ...eventParams,
            'Rated': rating === 1 ? 'Upvote' : 'Downvote',
          });
        }
      }

      const params = {
        rating: rating,
        ratingType: 'updown',
        rateableId: this.rateableId,
        rateableType: this.rateableType,
      };

      return this.$store.dispatch('ratings/create', params);
    },
    ratedAssetTitle(asset) {
      if (this.rateableType === 'Attachment'){
        return asset.name;
      } else if (this.rateableType === 'Topic') {
        return asset.title;
      }
    },
  },
};
